import React from 'react';
import EditProfile from "../components/EditProfile";

const EditProfilePage = () => {
    return (
        <React.Fragment >
            <EditProfile />
        </React.Fragment>
    );
};

export default EditProfilePage;